/**
 * Sale Delivery Challan / Gate Pass button. Opens a new tab with the
 * printable challan (backend assigns the DC number on first request,
 * then reuses it for subsequent reprints).
 */
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { FileText } from "@phosphor-icons/react";
import { saleDeliveryChallanHtml } from "@/components/saleDeliveryChallanHtml";

export default function PrintDeliveryChallanButton({ sale }) {
  const open = async () => {
    // Open the tab synchronously (before any await) so browser popup
    // blockers accept it — programmatic window.open after an async
    // resolves gets blocked in most browsers.
    const w = window.open("", "_blank", "width=1000,height=1200");
    if (!w) {
      toast.error("Popup blocked — allow popups for this site");
      return;
    }
    w.document.write("<html><body style='font-family:sans-serif;padding:24px'>Loading Delivery Challan…</body></html>");
    try {
      const { data } = await api.get(`/sales/${sale.id}/delivery-challan`);
      w.document.open();
      w.document.write(saleDeliveryChallanHtml(data));
      w.document.close();
    } catch (err) {
      w.document.body.innerHTML = `<pre style='color:#a00;padding:24px'>${formatApiError(err)}</pre>`;
      toast.error(formatApiError(err));
    }
  };
  return (
    <button
      type="button"
      onClick={open}
      data-testid={`dc-print-${sale.id}`}
      title="Print Delivery Challan / Gate Pass"
      className="p-1.5 border border-canvas-line hover:border-ink flex items-center gap-1"
    >
      <FileText size={12} weight="bold" />
    </button>
  );
}
